<script setup lang="ts">
const { t: $t } = useI18n()

import type { UserInfoUpsert } from '~/types'

defineEmits<{ (e: 'upsert'): UserInfoUpsert }>()

const { openUserInfoPopup: { data: popupData, close: closePopup } } = useGlobalOpeners()
const { userInfo } = useQuery()
const { data: userInfoData, isFetching } = userInfo.byEmail(popupData.value?.userEmail)

const payload = computed<UserInfoUpsert | undefined>(() => {
  if (!popupData.value?.userEmail || isFetching.value) {
    return undefined
  }

  return userInfoData.value ?? popupData.value
})

const { $trpc, queryClient, useMutation, makeTrpcErrorToast } = useMutationHelpers()
const notification = useNotification()

const upsert = useMutation({
  mutationFn: $trpc.userInfo.upsert.mutate,
  onError: makeTrpcErrorToast(notification, { description: $t('query.error', { entity: $t('userInfo.title') }) }),
  onSuccess: async () => {
    await queryClient.invalidateQueries({ queryKey: ['userInfo'] })

    closePopup()
    notification.success({ title: $t('query.success', { entity: $t('userInfo.title') }), duration: 4500 })
  },
})
</script>

<template>
  <ThePopup
    v-if="payload"
    :title="$t(`userInfo.page.${payload.id ? 'edit' : 'create'}.title`)"
    show
    @close="closePopup"
  >
    <UserInfoCreateOrEditForm :payload="payload" @save="upsert.mutate" />
  </ThePopup>
</template>
